import Button from "react-bootstrap/Button";
import { Col, Container, Form, Image, Modal, Row } from "react-bootstrap";
import React, { Component, useEffect } from "react";
import * as Yup from "yup";
import { Formik, useField, useFormikContext } from "formik";
import axios from "axios";
import { POSTAL, URL_PROVINCE } from "./lib/Constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getMonth, getYear, parse } from "date-fns";
import { STRINGS } from "./lib/Strings";
import Layout from "./Layout";
import PopupModal from "Components/Common/PopupModal/PopupModal";
import AppConstants from "Constants/AppConstants";
import moment from "moment";
import MaskedInput from "react-text-mask";
import { isDesktop, isMobile } from "react-device-detect";
import { scroller } from "react-scroll";
import {
  DEFAULT_BRAND,
  DEFAULT_LANGUAGE,
  S_SMART_VERIFY_BRAND,
  S_SMART_VERIFY_LANGUAGE,
  S_USER_ID,
  S_PHONE,
  S_EMAIL,
  S_LINK_SESSION_ID,
  TOKEN_KEY,
} from "../../Communication/Constants";
import { usePlaidLink } from "react-plaid-link";
import PlaidQrVerificationModal from "../AboutYou/PlaidQrVerificationModal";

const PLAID_VERIFICATION_STEP_KEYS = [
  "accept_tos",
  "documentary_verification",
  "kyc_check",
  "risk_check",
  "selfie_check",
  "verify_sms",
  "watchlist_screening",
];

const nameRegExp = /^[a-zA-ZàâäéèêëîïôöùûüÿçÀÂÄÉÈÊËÎÏÔÖÙÛÜŸÇ'’\-]+(?: [a-zA-ZàâäéèêëîïôöùûüÿçÀÂÄÉÈÊËÎÏÔÖÙÛÜŸÇ'’\-]+)*$/;
const CApostalCodeRegExp = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z] ?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

const prepareYup = () => {
  if (STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND]) {
    return Yup.object().shape({
      firstName: Yup.string()
        .nullable()
        .matches(
          nameRegExp,
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.NUMBERS_ERROR
        )
        .required(
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.FIRST_NAME_REQUIRED
        ),
      middleName: Yup.string()
        .nullable()
        .matches(
          nameRegExp,
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.NUMBERS_ERROR
        ),
      surName: Yup.string()
        .nullable()
        .matches(
          nameRegExp,
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.NUMBERS_ERROR
        )
        .required(
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.LAST_NAME_REQUIRED
        ),
      dob: Yup.string()
        .nullable()
        .required(
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.DOB_REQUIRED
        ),
      physicalAddress: Yup.string()
        .nullable()
        .required(
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.ADDRESS_REQUIRED
        ),
      city: Yup.string()
        .nullable()
        .matches(
          nameRegExp,
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.NUMBERS_ERROR
        )
        .required(
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.CITY_REQUIRED
        ),
      province: Yup.string()
        .nullable()
        .required(
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.PROVINCE_REQUIRED
        )
        .notOneOf(
          ["placeholderProvince"],
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.PROVINCE_REQUIRED
        ),
      zip: Yup.string()
        .nullable()
        .matches(
          CApostalCodeRegExp,
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.POSTAL_CODE_BAD_FORMAT
        )
        .required(
          STRINGS[
            sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND
          ][sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE]
            .REVIEW.ERROR_CODE.POSTAL_CODE_REQUIRED
        ),
    });
  } else {
    return null;
  }
};
let validationSchema = prepareYup();

const range = (start, end) => {
  const length = end - start;
  return Array.from({ length }, (_, i) => end - i);
};

export const DatePickerField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);
  const years = range(getYear(props.minDate), getYear(props.maxDate));
  const months = [
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.JAN,
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.FEB,
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.MAR,
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.APR,
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.MAY,
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.JUN,
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.JUL,
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.AUG,
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.SEP,
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.OCT,
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.NOV,
    STRINGS[sessionStorage.getItem(S_SMART_VERIFY_BRAND) || DEFAULT_BRAND][
      sessionStorage.getItem(S_SMART_VERIFY_LANGUAGE) || DEFAULT_LANGUAGE
    ].MONTHS.DEC,
  ];

  return (
    <DatePicker
      {...field}
      {...props}
      selected={(field.value && new Date(field.value)) || null}
      onChange={(val) => {
        setFieldValue(field.name, val);
      }}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div>
          <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            {"<"}
          </button>
          <select
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            {">"}
          </button>
        </div>
      )}
    />
  );
};
// Functional component that handles Plaid identity verification
const PlaidIdentityVerification = ({
  linkToken,
  onSuccess,
  onExit,
  onReady,
  onError,
}) => {
  const { open, ready, error } = usePlaidLink({
    token: linkToken,
    onSuccess,
    onExit,
  });

  useEffect(() => {
    if (error && onError) onError(error);
  }, [error]);

  useEffect(() => {
    if (ready) {
      open();
      if (onReady) onReady();
    }
  }, [ready, open]);

  return null;
};

export default class Review extends Component {
  constructor(props) {
    super(props);
    this.state = {
      verifyError: null,
      showModal: false,
      frontImage: null,
      firstName: "",
      middleName: "",
      dob: "",
      physicalAddress: "",
      city: "",
      province: "",
      zip: "",
      email: "",
      surName: "",
      loadInstntData: true,
      disableEdit: false,
      allowContinue: true,
      instData: null,
      provinceList: [],
      provinceCodeList: [],
      minDate: moment(new Date()).subtract(100, "y").toDate(),
      maxDate: moment(new Date()).subtract(18, "y").toDate(),
      idType: "",
      activeButton: "",
      validationFailed: false,
      linkToken: null,
      plaidLock: false,
      showPlaidQrModal: false,
      plaidShareableUrl: null,
      plaidAcceptTosSuccess: false,
    };

    this.infoNotCorrect = this.infoNotCorrect.bind(this);
    this.infoCorrect = this.infoCorrect.bind(this);
  }

  componentDidMount() {
    const { history, goToPage, language } = this.props;
    console.log("componentDidMount", language);
    const token = sessionStorage.getItem(TOKEN_KEY);
    validationSchema = prepareYup();
    if (!token) {
      goToPage("/");
    } else {
      const img = sessionStorage.getItem("SELFIE_IMAGE");
      this.setState({
        frontImage: img,
      });
      axios.get(URL_PROVINCE, {}).then((result) => {
        let provinceList = [];
        let provinceCodeList = [];
        provinceList = result.data[language].map((elem, idx) => {
          provinceCodeList.push(elem.code);
          return (
            <option
              value={elem.code}
              key={elem.code + "-" + elem.description}
              eventKey={idx}
              className="[ dropdown__option ]"
            >
              {elem.description}
            </option>
          );
        });

        // Resolve province immediately while provinceCodeList is available,
        // preventing a race condition where componentDidUpdate runs before
        // the province list is populated (provinceCodeList would be [] at that point).
        const newState = { provinceList, provinceCodeList };
        const currentInstntData = sessionStorage.getItem("INSTNT_DATA");
        if (currentInstntData) {
          const instData = JSON.parse(currentInstntData);
          const idType = sessionStorage.getItem("ID_TYPE");
          newState.firstName = instData.firstName || "";
          newState.middleName = instData.middleName || "";
          newState.surName = instData.surName || "";
          newState.dob = instData.dateOfBirth
            ? parse(instData.dateOfBirth, "yyyy-MM-dd", new Date())
            : "";
          newState.physicalAddress = instData.address || "";
          newState.city = instData.city || "";
          newState.province = provinceCodeList.includes(instData.state)
            ? instData.state
            : "placeholderProvince";
          newState.zip = instData.postalCode || "";
          newState.loadInstntData = false;
          newState.disableEdit = idType === "Passport" ? false : true;
          newState.allowContinue = idType === "Passport" ? true : false;
          newState.instData = instData;
          newState.idType = idType;
        }

        this.setState(newState);
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log("componentDidUpdate");
    const { loadInstntData } = this.state;
    if (loadInstntData) {
      const currentInstntData = sessionStorage.getItem("INSTNT_DATA");
      const idType = sessionStorage.getItem("ID_TYPE");
      if (currentInstntData) {
        const instData = JSON.parse(currentInstntData);
        console.log("loading instData", instData.firstName);
        this.setState({
          firstName: instData.firstName || "",
          middleName: instData.middleName || "",
          surName: instData.surName || "",
          dob: instData.dateOfBirth
            ? parse(instData.dateOfBirth, "yyyy-MM-dd", new Date())
            : "",
          physicalAddress: instData.address || "",
          city: instData.city || "",
          province: this.state.provinceCodeList.includes(instData.state)
            ? instData.state
            : "placeholderProvince",
          zip: instData.postalCode || "",
          loadInstntData: false,
          disableEdit: idType === "Passport" ? false : true,
          allowContinue: idType === "Passport" ? true : false,
          instData,
          idType,
        });
      }
    }
  }

  submitInfo = (
    firstName,
    middleName,
    surName,
    dob,
    physicalAddress,
    city,
    province,
    zip
  ) => {
    const { doGetPlaidToken } = this.props;

    // user.client_user_id: S_USER_ID from session storage
    const clientUserId = sessionStorage.getItem(S_USER_ID);

    // user.phone_number: "+" + S_PHONE from session storage
    const rawPhone = sessionStorage.getItem(S_PHONE) || "";
    const phoneNumber = rawPhone ? `+${rawPhone}` : undefined;

    // user.email_address: S_EMAIL from session storage
    const emailAddress = sessionStorage.getItem(S_EMAIL) || undefined;

    // user.name.given_name: firstName, appended with middleName if provided
    const givenName = middleName
      ? `${firstName} ${middleName}`.trim()
      : firstName;

    // user.date_of_birth: format as YYYY-MM-DD
    const dateOfBirth = dob ? moment(dob).format("YYYY-MM-DD") : undefined;

    // user.address.postal_code: alphanumeric only, uppercased, special chars stripped
    const postalCode = zip
      ? zip.replace(/[^a-zA-Z0-9]/g, "").toUpperCase()
      : undefined;

    // user.address.region: uppercased province/state abbreviation
    const region =
      province && province !== "placeholderProvince"
        ? province.toUpperCase()
        : undefined;

    // user.address.country: 2-letter ISO 3166-1 alpha-2, uppercased
    const country = "CA";

    // Build user address object; omit street2 entirely if not provided
    const address = {
      street: physicalAddress || undefined,
      city: city || undefined,
      region,
      postal_code: postalCode,
      country,
    };

    // Build user object
    const user = {
      client_user_id: clientUserId,
      ...(phoneNumber && { phone_number: phoneNumber }),
      ...(emailAddress && { email_address: emailAddress }),
      name: {
        given_name: givenName,
        family_name: surName,
      },
      ...(dateOfBirth && { date_of_birth: dateOfBirth }),
      address,
    };

    const { doLoadingStart } = this.props;
    doLoadingStart("PLAID_LOADING");

    const requestData = {
      user,
      products: ["identity_verification"],
      country_codes: ["CA"],
      language: "en",
      identity_verification: {
        template_id: process.env.REACT_APP_PLAID_TEMPLATE_ID || undefined,
        gave_consent: false,
      },
    };

    console.log("Requesting Plaid token", requestData);

    doGetPlaidToken(requestData, (result) => {
      console.log("Plaid token result", result);
      if (result && result.data && result.data.link_token) {
        this.setState({ linkToken: result.data.link_token, plaidLock: true });
        // Spinner stays active until PlaidIdentityVerification fires onReady
      } else {
        console.error("Failed to get Plaid link token", result);
        const { doLoadingFinish } = this.props;
        doLoadingFinish("PLAID_LOADING");
        sessionStorage.setItem("END_FLAG", "ERROR");
      }
    });
  };

  handlePlaidReady = () => {
    const { doLoadingFinish } = this.props;
    doLoadingFinish("PLAID_LOADING");
  };

  handlePlaidError = () => {
    const { doLoadingFinish } = this.props;
    doLoadingFinish("PLAID_LOADING");
    this.setState({
      linkToken: null,
      verifyError:
        "We're having trouble loading the verification service. Please check your connection and try again.",
    });
  };

  handlePlaidErrorDismiss = () => {
    this.setState({ verifyError: null });
  };

  arePlaidVerificationStepsComplete = (steps) => {
    if (!steps) {
      return false;
    }
    return PLAID_VERIFICATION_STEP_KEYS.every(
      (key) =>
        steps[key] === "success" ||
        steps[key] === "not_applicable" ||
        steps[key] === "failed"
    );
  };

  stopPlaidListPolling = () => {
    if (this._plaidListPollInterval) {
      clearInterval(this._plaidListPollInterval);
      this._plaidListPollInterval = null;
    }
  };

  startPlaidListPolling = () => {
    this.stopPlaidListPolling();
    this._plaidListPollInterval = setInterval(
      this.pollPlaidListVerifications,
      30000
    );
  };

  pollPlaidListVerifications = () => {
    const { doGetPlaidListVerifications } = this.props;
    const { showPlaidQrModal } = this.state;
    const clientUserId = sessionStorage.getItem(S_USER_ID);

    if (!showPlaidQrModal || !clientUserId) {
      return;
    }

    doGetPlaidListVerifications(clientUserId, (result) => {
      this.processPlaidListVerificationsResult(result, { fromPoll: true });
    });
  };

  completePlaidQrVerification = (verifications) => {
    this.stopPlaidListPolling();
    this.setState({
      showPlaidQrModal: false,
      plaidShareableUrl: null,
      plaidAcceptTosSuccess: false,
    });
    this.handlePlaidSuccess(null, {
      link_session_id:
        this._plaidLinkSessionId || sessionStorage.getItem(S_LINK_SESSION_ID),
    });
  };

  processPlaidListVerificationsResult = (result, { fromPoll = false } = {}) => {
    const verifications = result?.data?.identity_verifications;
    if (!Array.isArray(verifications) || verifications.length === 0) {
      return;
    }

    const lastVerification = verifications[verifications.length - 1];
    const shareableUrl = lastVerification?.shareable_url;

    if (this.arePlaidVerificationStepsComplete(lastVerification?.steps)) {
      this.completePlaidQrVerification(verifications);
      return;
    }

    if (!shareableUrl) {
      return;
    }

    const acceptTosSuccess = lastVerification?.steps?.accept_tos === "success";
    const modalUpdate = {
      plaidShareableUrl: shareableUrl,
      plaidAcceptTosSuccess: acceptTosSuccess,
    };

    if (fromPoll) {
      this.setState(modalUpdate);
      return;
    }

    this.setState(
      {
        showPlaidQrModal: true,
        ...modalUpdate,
      },
      () => this.startPlaidListPolling()
    );
  };

  handlePlaidQrModalClose = () => {
    this.stopPlaidListPolling();
    this.setState({
      showPlaidQrModal: false,
      plaidShareableUrl: null,
      plaidAcceptTosSuccess: false,
    });
  };

  handlePlaidQrCancel = () => {
    this.stopPlaidListPolling();
    window.location.reload();
  };

  showPlaidQrFromListResult = (result) => {
    this.processPlaidListVerificationsResult(result);
  };

  componentWillUnmount() {
    this.stopPlaidListPolling();
  }

  handlePlaidSuccess = (publicToken, metadata) => {
    console.log("Plaid identity verification success", publicToken, metadata);
    if (this._plaidSuccessHandled) {
      return;
    }
    const linkSessionId =
      metadata?.link_session_id || sessionStorage.getItem(S_LINK_SESSION_ID);
    if (!linkSessionId) {
      console.warn(
        "[Plaid] handlePlaidSuccess: missing link_session_id",
        metadata
      );
      return;
    }
    this._plaidSuccessHandled = true;
    sessionStorage.setItem("END_FLAG", "SUCCESS");
    sessionStorage.setItem(S_LINK_SESSION_ID, linkSessionId);
    const {
      goToPage,
      doGetPlaidVerification,
      doKycPlaidEmail,
      doLoadingStart,
      doLoadingFinish,
    } = this.props;
    doLoadingStart("PLAID_LOADING");
    this.setState({ linkToken: null });
    doGetPlaidVerification(linkSessionId, (result) => {
      console.log("Plaid verification result", result);
      const email =
        result?.data?.user?.email_address || sessionStorage.getItem(S_EMAIL);
      if (result.data.user && !result?.data?.user?.email_address) {
        result.data.user.email_address = sessionStorage.getItem(S_EMAIL);
      }
      doKycPlaidEmail({ ...result.data }, (emailResult) => {
        console.log("Plaid KYC email result", emailResult);
        doLoadingFinish("PLAID_LOADING");
        this._plaidSuccessHandled = false;
        goToPage("/end");
      });
    });
  };

  handlePlaidExitForCreate = (error, metadata) => {
    console.log("[Plaid] handlePlaidExitForCreate fired", error, metadata);
    if (this._plaidSuccessHandled) {
      return;
    }
    if (sessionStorage.getItem("END_FLAG") === "SUCCESS") {
      return;
    }
    const { doGetPlaidListVerifications, doLoadingFinish } = this.props;
    if (metadata?.link_session_id) {
      this._plaidLinkSessionId = metadata.link_session_id;
      sessionStorage.setItem(S_LINK_SESSION_ID, metadata.link_session_id);
    }
    doLoadingFinish("PLAID_LOADING");
    this.setState({ linkToken: null });
    if (!error && isDesktop) {
      const clientUserId = sessionStorage.getItem(S_USER_ID);
      doGetPlaidListVerifications(clientUserId, (result) => {
        console.log(
          "[Plaid] getPlaidListVerifications callback result",
          result
        );
        this.showPlaidQrFromListResult(result);
      });
      return;
    }
    sessionStorage.setItem("END_FLAG", "ERROR");
    const { goToPage } = this.props;
    goToPage("/end");
  };

  // Handle when the "No" button is clicked
  infoNotCorrect() {
    const { activeButton } = this.state;
    if (activeButton !== "no") {
      console.log("incorrect");
      this.setState(
        {
          disableEdit: false,
          allowContinue: true,
          activeButton: "no",
        },
        () => {
          // Ensure the state is updated before scrolling
          console.log("Scrolling to myScrollElement");
          scroller.scrollTo("myScrollElement", {
            duration: 500,
            delay: 0,
            smooth: true,
            // offset: -32,
          });
        }
      );
    }
  }

  // Handle when the "Yes" button is clicked
  infoCorrect() {
    const { activeButton } = this.state;
    if (activeButton !== "yes") {
      console.log("correct");
      this.setState({
        disableEdit: true,
        allowContinue: true,
        activeButton: "yes",
      });
    }
  }

  handleClose() {
    const { history, goToPage } = this.props;
    goToPage("/");
  }

  setDOB = (value) => {
    this.setState({
      dob: value,
    });
  };

  render() {
    console.log("render");
    const {
      showModal,
      verifyError,
      frontImage,
      firstName,
      middleName,
      surName,
      dob,
      physicalAddress,
      city,
      province,
      zip,
      disableEdit,
      allowContinue,
      provinceList,
      minDate,
      maxDate,
      idType,
      activeButton,
      validationFailed,
      linkToken,
      plaidLock,
      showPlaidQrModal,
      plaidShareableUrl,
      plaidAcceptTosSuccess,
    } = this.state;
    const { history, brand, language, goToPage } = this.props;
    return (
      <>
        {verifyError && (
          <PopupModal
            type={AppConstants.MODALTYPE.FAILURE}
            description={verifyError}
            showModal={!!verifyError}
            toggleModal={this.handlePlaidErrorDismiss}
            popupBtnClick={this.handlePlaidErrorDismiss}
            btnText="OK"
          />
        )}
        <PlaidQrVerificationModal
          show={showPlaidQrModal}
          shareableUrl={plaidShareableUrl}
          acceptTosSuccess={plaidAcceptTosSuccess}
          onClose={this.handlePlaidQrModalClose}
          onCancel={this.handlePlaidQrCancel}
        />
        <Layout
          history={history}
          brand={brand}
          language={language}
          goToPage={goToPage}
        >
          <Modal
            show={showModal}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={this.handleClose.bind(this)}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                {STRINGS[brand][language].MODAL_SUBMIT_SUCCESS.HEADER_TITLE}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Image src="/check.png" />
              <p>{STRINGS[brand][language].MODAL_SUBMIT_SUCCESS.BODY_0}</p>
              <p>{STRINGS[brand][language].MODAL_SUBMIT_SUCCESS.BODY_1}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleClose.bind(this)}>
                {STRINGS[brand][language].MODAL.OK}
              </Button>
            </Modal.Footer>
          </Modal>
          <Formik
            enableReinitialize
            initialValues={{
              firstName,
              middleName,
              surName,
              dob,
              physicalAddress,
              city,
              province,
              zip,
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              console.log("testing");
              setSubmitting(true);
              this.submitInfo(
                values.firstName,
                values.middleName,
                values.surName,
                values.dob,
                values.physicalAddress,
                values.city,
                values.province,
                values.zip
              );
            }}
            validate={(values) => {
              // If validation errors exist and user had clicked "Yes", enable editing
              const errors = {};
              if (this.state.disableEdit && this.state.activeButton === "yes") {
                // Check if there are any validation errors
                try {
                  validationSchema.validateSync(values, { abortEarly: false });
                  this.setState({
                    validationFailed: false,
                  });
                } catch (err) {
                  // Validation failed, enable editing so user can fix errors
                  this.setState({
                    validationFailed: true,
                  });
                }
              }
              return errors;
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Container className="form-fields inner-smartVerify">
                  <Row>
                    <Col sm={12}>
                      <h1>
                        {STRINGS[brand][language].REVIEW.DESKTOP.HEADER_TITLE}
                      </h1>
                    </Col>
                    <Col sm={12}>
                      <h3>
                        {STRINGS[brand][language].REVIEW.DESKTOP.SUBTITLE}
                      </h3>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <h2>
                        {
                          STRINGS[brand][language].REVIEW
                            .SECTION_HEADER_PERSONAL
                        }
                      </h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3}>
                      <Form.Group controlId="formCode">
                        <Form.Label>
                          {
                            STRINGS[brand][language].REVIEW.FORM
                              .FIRST_NAME_LABEL
                          }
                        </Form.Label>
                        <Form.Control
                          size="lg"
                          disabled={disableEdit || plaidLock}
                          type="text"
                          name="firstName"
                          placeholder={
                            STRINGS[brand][language].REVIEW.FORM
                              .FIRST_NAME_PLACEHOLDER
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.firstName}
                          className={
                            touched.firstName && errors.firstName
                              ? "has-error"
                              : null
                          }
                        />
                        {touched.firstName && errors.firstName ? (
                          <div className="error-message">
                            {errors.firstName}
                          </div>
                        ) : null}
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formMiddleName">
                        <Form.Label>
                          {
                            STRINGS[brand][language].REVIEW.FORM
                              .MIDDLE_NAME_LABEL
                          }
                        </Form.Label>
                        <Form.Control
                          size="lg"
                          disabled={disableEdit || plaidLock}
                          type="text"
                          name="middleName"
                          placeholder={
                            STRINGS[brand][language].REVIEW.FORM
                              .MIDDLE_NAME_PLACEHOLDER
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.middleName}
                          className={
                            touched.middleName && errors.middleName
                              ? "has-error"
                              : null
                          }
                        />
                        {touched.middleName && errors.middleName ? (
                          <div className="error-message">
                            {errors.middleName}
                          </div>
                        ) : null}
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formLastName">
                        <Form.Label>
                          {STRINGS[brand][language].REVIEW.FORM.LAST_NAME_LABEL}
                        </Form.Label>
                        <Form.Control
                          size="lg"
                          disabled={disableEdit || plaidLock}
                          type="text"
                          name="surName"
                          placeholder={
                            STRINGS[brand][language].REVIEW.FORM
                              .LAST_NAME_PLACEHOLDER
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.surName}
                          className={
                            touched.surName && errors.surName
                              ? "has-error"
                              : null
                          }
                        />
                        {touched.surName && errors.surName ? (
                          <div className="error-message">{errors.surName}</div>
                        ) : null}
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formDOB">
                        <Form.Label>
                          {STRINGS[brand][language].REVIEW.FORM.DOB_LABEL}
                        </Form.Label>
                        <DatePickerField
                          name="dob"
                          id="dob"
                          showYearDropdown
                          showMonthDropdown
                          minDate={minDate}
                          maxDate={maxDate}
                          yearDropdownItemNumber={60}
                          placeholderText={
                            STRINGS[brand][language].REVIEW.FORM.DOB_PLACEHOLDER
                          }
                          selected={values.dob}
                          disabled={disableEdit || plaidLock}
                          onBlur={handleBlur}
                          dateFormat="yyyy-MM-dd"
                          onChange={(date) => this.setDOB(date)}
                          className="[datepicker form-control form-control-lg ]"
                        />
                        {touched.dob && errors.dob ? (
                          <div className="error-message">{errors.dob}</div>
                        ) : null}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <h2>
                        {STRINGS[brand][language].REVIEW.SECTION_HEADER_ADDRESS}
                      </h2>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <Form.Group controlId="formAddress">
                        <Form.Label>
                          {
                            STRINGS[brand][language].REVIEW.FORM
                              .STREET_ADDRESS_LABEL
                          }
                        </Form.Label>
                        <Form.Control
                          size="lg"
                          disabled={disableEdit || plaidLock}
                          type="text"
                          name="physicalAddress"
                          placeholder={
                            STRINGS[brand][language].REVIEW.FORM
                              .STREET_ADDRESS_PLACEHOLDER
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.physicalAddress}
                          className={
                            touched.physicalAddress && errors.physicalAddress
                              ? "has-error"
                              : null
                          }
                        />
                        {touched.physicalAddress && errors.physicalAddress ? (
                          <div className="error-message">
                            {errors.physicalAddress}
                          </div>
                        ) : null}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="formCity">
                        <Form.Label>
                          {STRINGS[brand][language].REVIEW.FORM.CITY_LABEL}
                        </Form.Label>
                        <Form.Control
                          size="lg"
                          disabled={disableEdit || plaidLock}
                          type="text"
                          name="city"
                          placeholder={
                            STRINGS[brand][language].REVIEW.FORM
                              .CITY_PLACEHOLDER
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.city}
                          className={
                            touched.city && errors.city ? "has-error" : null
                          }
                        />
                        {touched.city && errors.city ? (
                          <div className="error-message">{errors.city}</div>
                        ) : null}
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="selectId">
                        <Form.Label>
                          {STRINGS[brand][language].REVIEW.FORM.PROVINCE_LABEL}
                        </Form.Label>
                        <Form.Control
                          size="lg"
                          as="select"
                          name="province"
                          disabled={disableEdit || plaidLock}
                          value={values.province}
                          className={
                            touched.province && errors.province
                              ? "has-error"
                              : null
                          }
                          onChange={handleChange}
                        >
                          <option
                            className="[ dropdown__option ]"
                            value="placeholderProvince"
                          >
                            {
                              STRINGS[brand][language].REVIEW.FORM
                                .PROVINCE_PLACEHOLDER
                            }
                          </option>
                          {provinceList}
                        </Form.Control>
                        {touched.province && errors.province ? (
                          <div className="error-message">{errors.province}</div>
                        ) : null}
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formPostal">
                        <Form.Label>
                          {
                            STRINGS[brand][language].REVIEW.FORM
                              .POSTAL_CODE_LABEL
                          }
                        </Form.Label>
                        <MaskedInput
                          disabled={disableEdit || plaidLock}
                          mask={POSTAL.CA_POSTALMASK}
                          className={
                            touched.zip && errors.zip
                              ? "form-control form-control-lg has-error"
                              : "form-control form-control-lg"
                          }
                          placeholder={
                            STRINGS[brand][language].REVIEW.FORM
                              .POSTAL_CODE_PLACEHOLDER
                          }
                          guide={false}
                          id="zip"
                          name="zip"
                          value={values.zip}
                          onChange={handleChange}
                          onBlur={(event) => {
                            if (
                              !event.target.value ||
                              event.target.value.trim() === ""
                            ) {
                              handleChange(event);
                            }
                          }}
                        />
                        {touched.zip && errors.zip ? (
                          <div className="error-message">{errors.zip}</div>
                        ) : null}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="submit-btn-container">
                    <Col md={{ span: 6, offset: 3 }}>
                      <Button
                        type="submit"
                        variant="primary"
                        block
                        size="lg"
                        disabled={plaidLock}
                      >
                        {STRINGS[brand][language].REVIEW.CONTINUE_CTA}
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Form>
            )}
          </Formik>
          {linkToken && (
            <PlaidIdentityVerification
              linkToken={linkToken}
              onSuccess={this.handlePlaidSuccess}
              onExit={this.handlePlaidExitForCreate}
              onReady={this.handlePlaidReady}
              onError={this.handlePlaidError}
            />
          )}
          <br />
          <br />
        </Layout>
      </>
    );
  }
}
